module.exports = __webpack_public_path__ + "media/flags/hk-1eb36876.svg";